// Canonical locale. All other locales must satisfy `typeof ptBR`.
export const ptBR = {
    common: {
        appName: 'Supadown',
        accept: 'Aceitar',
        cancel: 'Cancelar',
        loading: 'Carregando...',
        back: 'Voltar',
        notFound: '404',
        notFoundBody: 'Essa página não existe.',
        skipToContent: 'Pular para o conteúdo',
        language: 'Idioma',
        toggleTheme: 'Alternar tema',
        themeLight: 'Claro',
        themeDark: 'Escuro',
        themeSystem: 'Sistema',
    },
    nav: {
        legal: 'Termos e privacidade',
        backHome: 'Voltar ao início',
        howTo: 'Como copiar o link',
    },
    home: {
        tagline: 'Salvou. Pronto.',
        seoHeading: 'Download de vídeos do YouTube, Instagram e TikTok — grátis e online',
        seoDescription: 'Supadown é um downloader de vídeos online gratuito. Baixe vídeos do YouTube, Instagram Reels, TikTok, Facebook, X (Twitter), LinkedIn, Kwai e Pinterest. Sem instalação, sem cadastro.',
        paste: 'Cole o link do vídeo',
        analyze: 'Analisar',
        download: 'Baixar',
        downloading: 'Baixando...',
        invalidUrl: 'Link inválido. Cole a URL completa do vídeo.',
        unsupported: 'Plataforma ainda não suportada.',
        serverError: 'Algo deu errado. Tente novamente em instantes.',
        details: 'Detalhes do vídeo',
        channel: 'Canal',
        duration: 'Duração',
        views: 'Visualizações',
        quality: 'Qualidade',
        supportedPlatforms: 'Plataformas suportadas',
    },
    platforms: {
        items: {
            youtube: { name: 'YouTube', description: 'Vídeos, Shorts e Lives públicos' },
            instagram: { name: 'Instagram', description: 'Posts, Reels e Stories públicos' },
            facebook: { name: 'Facebook', description: 'Vídeos públicos do Facebook' },
            twitter: { name: 'Twitter / X', description: 'Vídeos de posts públicos' },
            linkedin: { name: 'LinkedIn', description: 'Posts públicos e LinkedIn Learning' },
            tiktok: { name: 'TikTok', description: 'Vídeos públicos do TikTok' },
            kwai: { name: 'Kwai', description: 'Vídeos públicos do Kwai' },
            pinterest: { name: 'Pinterest', description: 'Pins com vídeo' },
        },
    },
    legal: {
        pageTitle: 'Termos e privacidade',
        intro: 'O Supadown é destinado a uso pessoal, educacional, jornalístico e de arquivamento de conteúdo público. Respeite os direitos autorais e os termos de uso das plataformas de origem.',
        privacy: {
            title: 'Privacidade',
            body: 'Não armazenamos URLs processadas após o download. Logs são anonimizados. IPs são truncados em /24 e removidos após 24 horas. Nenhum cookie de rastreamento é usado.',
        },
        contact: {
            title: 'Contato',
            body: 'Dúvidas, abusos ou pedidos de remoção: hello@supadown.com.',
        },
    },
    legalGate: {
        title: 'Antes de continuar',
        body: 'O Supadown deve ser usado apenas para conteúdo público e para fins legítimos (arquivamento pessoal, uso educacional, pesquisa, jornalismo). Respeite os direitos autorais de cada plataforma.',
        contactLine: 'Dúvidas ou pedidos de remoção: hello@supadown.com.',
    },
    footer: {
        copyright: '© Supadown',
        contact: 'hello@supadown.com',
    },
    seo: {
        faqTitle: 'Perguntas frequentes',
        faqGuideLink: 'Ver guia passo a passo →',
        faq: [
            { q: 'Como baixar vídeos do YouTube?', a: 'Cole o link do YouTube no campo acima e clique no botão de busca. O Supadown vai analisar o vídeo e mostrar as opções de download.' },
            { q: 'O Supadown é gratuito?', a: 'Sim, o Supadown é totalmente gratuito. Sem cadastro, sem taxas escondidas.' },
            { q: 'O Supadown armazena meus dados?', a: 'Não. Não armazenamos URLs nem dados pessoais após o download. Nenhum cookie de rastreamento é usado.' },
            { q: 'Quais plataformas são suportadas?', a: 'YouTube, Instagram, TikTok, Facebook, X (Twitter), LinkedIn, Kwai e Pinterest.' },
            { q: 'Preciso instalar alguma coisa?', a: 'Não. O Supadown funciona direto no navegador. Sem apps, extensões ou software.' },
            { q: 'Como baixar vídeos do Instagram Reels?', a: 'Copie o link do Reel no Instagram, cole no Supadown e clique no botão de busca. O download estará disponível em segundos.' },
            { q: 'O Supadown funciona no celular?', a: 'Sim. O Supadown funciona em qualquer dispositivo com navegador — celular, tablet ou computador. Sem instalar nada.' },
            { q: 'Como baixar vídeos do TikTok?', a: 'Cole o link do TikTok no Supadown. O vídeo será baixado na melhor qualidade disponível pela plataforma.' },
            { q: 'Posso baixar vídeos em HD ou 4K?', a: 'Sim. O Supadown mostra todas as qualidades disponíveis — de 360p até 4K — para você escolher a que preferir.' },
            { q: 'Como baixar Shorts do YouTube?', a: 'Copie o link do Short no YouTube e cole no Supadown. Shorts são tratados como qualquer outro vídeo.' },
            { q: 'O Supadown funciona sem cadastro?', a: 'Sim. Nenhum cadastro é necessário. Basta colar o link e baixar.' },
            { q: 'Posso baixar apenas o áudio de um vídeo?', a: 'Sim. O Supadown mostra opções de áudio separadas quando disponíveis na plataforma de origem.' },
        ],
    },
    howTo: {
        title: 'Como copiar o link do vídeo',
        intro: 'Para baixar um vídeo, você precisa copiar o link dele na plataforma de origem. Veja como fazer em cada uma:',
        tryIt: 'Baixar agora',
        platforms: {
            youtube: {
                title: 'YouTube',
                steps: [
                    'Abra o vídeo no YouTube (app ou navegador).',
                    'Toque em "Compartilhar" abaixo do vídeo.',
                    'Toque em "Copiar link".',
                    'Cole o link no Supadown e clique no botão de busca.',
                ],
            },
            instagram: {
                title: 'Instagram',
                steps: [
                    'Abra o post ou Reel no Instagram.',
                    'Toque nos três pontos (⋯) no canto superior direito.',
                    'Toque em "Copiar link".',
                    'Cole o link no Supadown.',
                ],
            },
            tiktok: {
                title: 'TikTok',
                steps: [
                    'Abra o vídeo no TikTok.',
                    'Toque no botão "Compartilhar" (seta).',
                    'Toque em "Copiar link".',
                    'Cole o link no Supadown.',
                ],
            },
            facebook: {
                title: 'Facebook',
                steps: [
                    'Abra o vídeo ou Reel no Facebook.',
                    'Toque nos três pontos (⋯) no canto superior direito do post.',
                    'Toque em "Copiar link".',
                    'Cole o link no Supadown.',
                ],
            },
            twitter: {
                title: 'X (Twitter)',
                steps: [
                    'Abra o tweet com o vídeo no X.',
                    'Toque no botão de compartilhar (seta).',
                    'Toque em "Copiar link".',
                    'Cole o link no Supadown.',
                ],
            },
            linkedin: {
                title: 'LinkedIn',
                steps: [
                    'Abra o post com vídeo no LinkedIn.',
                    'Toque nos três pontos (⋯) no canto superior direito.',
                    'Toque em "Copiar link para a publicação".',
                    'Cole o link no Supadown.',
                ],
            },
            kwai: {
                title: 'Kwai',
                steps: [
                    'Abra o vídeo no Kwai.',
                    'Toque no botão "Compartilhar".',
                    'Toque em "Copiar link".',
                    'Cole o link no Supadown.',
                ],
            },
            pinterest: {
                title: 'Pinterest',
                steps: [
                    'Abra o Pin com vídeo no Pinterest.',
                    'Toque no botão de compartilhar.',
                    'Toque em "Copiar link".',
                    'Cole o link no Supadown.',
                ],
            },
        },
    },
    platformSeo: {
        otherPlatforms: 'Outras plataformas',
        youtube: {
            chipLabel: 'YouTube',
            title: 'Baixar Vídeos do YouTube Grátis',
            description: 'Baixe vídeos do YouTube em HD e 4K grátis. Supadown é o downloader de YouTube mais rápido e seguro. Sem instalação, sem cadastro.',
            heading: 'Baixar vídeos do YouTube — grátis e online',
            intro: 'O Supadown permite baixar vídeos do YouTube em qualquer qualidade, de 360p até 4K. Funciona com vídeos normais, Shorts e Lives públicas. Basta colar o link do vídeo, escolher a qualidade desejada e clicar em baixar. Sem necessidade de instalar programas ou extensões.',
            cta: 'Baixar vídeo do YouTube agora →',
            faq: [
                { q: 'Posso baixar vídeos do YouTube em 4K?', a: 'Sim. O Supadown mostra todas as resoluções disponíveis incluindo 720p, 1080p, 1440p e 4K. Basta escolher a qualidade desejada.' },
                { q: 'Como baixar YouTube Shorts?', a: 'Copie o link do Short e cole no Supadown. Shorts são tratados como vídeos normais — você escolhe a qualidade e baixa.' },
                { q: 'Posso baixar apenas o áudio de um vídeo do YouTube?', a: 'Sim. O Supadown exibe opções de áudio separadas (M4A) quando disponíveis, ideal para músicas e podcasts.' },
            ],
        },
        instagram: {
            chipLabel: 'Instagram',
            title: 'Baixar Vídeos do Instagram Grátis',
            description: 'Baixe Reels, Stories e vídeos do Instagram grátis. Downloader rápido e sem cadastro. Funciona no celular e computador.',
            heading: 'Baixar vídeos e Reels do Instagram — grátis e online',
            intro: 'Baixe vídeos do Instagram incluindo Reels, Stories e posts com vídeo. O Supadown analisa o link e oferece o download na melhor qualidade disponível. Funciona em qualquer dispositivo com navegador, sem precisar instalar aplicativos.',
            cta: 'Baixar vídeo do Instagram agora →',
            faq: [
                { q: 'Posso baixar Reels do Instagram?', a: 'Sim. Copie o link do Reel e cole no Supadown. O vídeo será baixado na qualidade original.' },
                { q: 'Consigo baixar Stories do Instagram?', a: 'Sim, desde que o perfil seja público. Copie o link da Story e cole no Supadown.' },
                { q: 'Funciona com perfis privados?', a: 'Não. O Supadown baixa apenas conteúdo de perfis públicos. Conteúdo privado requer autenticação que não oferecemos.' },
            ],
        },
        tiktok: {
            chipLabel: 'TikTok',
            title: 'Baixar Vídeos do TikTok Grátis',
            description: 'Baixe vídeos do TikTok grátis e online. Downloader rápido, sem marca d\'água garantida, sem cadastro.',
            heading: 'Baixar vídeos do TikTok — grátis e online',
            intro: 'Baixe vídeos do TikTok rapidamente com o Supadown. Cole o link do vídeo, clique em buscar e baixe na melhor qualidade disponível. Funciona direto no navegador, sem instalar aplicativos ou extensões.',
            cta: 'Baixar vídeo do TikTok agora →',
            faq: [
                { q: 'O vídeo do TikTok vem sem marca d\'água?', a: 'O Supadown baixa o vídeo na melhor qualidade disponível pela plataforma. A presença de marca d\'água depende da fonte do vídeo no TikTok.' },
                { q: 'Posso baixar TikTok no celular?', a: 'Sim. O Supadown funciona em qualquer navegador de celular — Chrome, Safari, Firefox, etc.' },
                { q: 'Preciso de conta no TikTok para baixar?', a: 'Não. Basta ter o link do vídeo público. Nenhuma conta é necessária.' },
            ],
        },
        facebook: {
            chipLabel: 'Facebook',
            title: 'Baixar Vídeos do Facebook Grátis',
            description: 'Baixe vídeos e Reels do Facebook grátis. Downloader online rápido e sem cadastro.',
            heading: 'Baixar vídeos do Facebook — grátis e online',
            intro: 'Baixe vídeos públicos do Facebook incluindo Reels e vídeos de páginas. Cole o link do vídeo no Supadown, escolha a qualidade e baixe. Sem instalação, sem cadastro, sem complicação.',
            cta: 'Baixar vídeo do Facebook agora →',
            faq: [
                { q: 'Posso baixar Reels do Facebook?', a: 'Sim. Copie o link do Reel no Facebook e cole no Supadown. O download funciona como qualquer outro vídeo.' },
                { q: 'Funciona com vídeos de grupos?', a: 'Apenas se o grupo e o vídeo forem públicos. Vídeos de grupos privados não podem ser acessados.' },
                { q: 'Em qual qualidade o vídeo é baixado?', a: 'O Supadown mostra todas as qualidades disponíveis. Geralmente HD (720p) e Full HD (1080p).' },
            ],
        },
        twitter: {
            chipLabel: 'X (Twitter)',
            title: 'Baixar Vídeos do X (Twitter) Grátis',
            description: 'Baixe vídeos do X (Twitter) grátis e online. Downloader rápido, sem cadastro.',
            heading: 'Baixar vídeos do X (Twitter) — grátis e online',
            intro: 'Baixe vídeos de tweets públicos no X (antigo Twitter). Cole o link do tweet que contém o vídeo no Supadown e baixe na qualidade desejada. Rápido, gratuito e sem cadastro.',
            cta: 'Baixar vídeo do X agora →',
            faq: [
                { q: 'Como pego o link de um tweet?', a: 'Abra o tweet, toque no botão de compartilhar e depois em "Copiar link". Cole o link no Supadown.' },
                { q: 'Funciona com tweets protegidos?', a: 'Não. Apenas tweets de contas públicas podem ser baixados.' },
                { q: 'GIFs do Twitter podem ser baixados?', a: 'Sim. GIFs no Twitter são na verdade vídeos curtos em loop — o Supadown baixa como MP4.' },
            ],
        },
        linkedin: {
            chipLabel: 'LinkedIn',
            title: 'Baixar Vídeos do LinkedIn Grátis',
            description: 'Baixe vídeos do LinkedIn grátis. Downloader online para vídeos de posts públicos.',
            heading: 'Baixar vídeos do LinkedIn — grátis e online',
            intro: 'Baixe vídeos de posts públicos do LinkedIn com o Supadown. Cole o link da publicação, analise e baixe. Ideal para salvar apresentações, webinars e conteúdo profissional.',
            cta: 'Baixar vídeo do LinkedIn agora →',
            faq: [
                { q: 'Posso baixar vídeos do LinkedIn Learning?', a: 'O Supadown funciona com posts públicos do LinkedIn. Vídeos do LinkedIn Learning são protegidos por assinatura.' },
                { q: 'O vídeo perde qualidade?', a: 'Não. O Supadown baixa na qualidade original publicada pelo autor.' },
            ],
        },
        kwai: {
            chipLabel: 'Kwai',
            title: 'Baixar Vídeos do Kwai Grátis',
            description: 'Baixe vídeos do Kwai grátis e online. Downloader rápido, sem cadastro.',
            heading: 'Baixar vídeos do Kwai — grátis e online',
            intro: 'Baixe vídeos do Kwai rapidamente com o Supadown. Copie o link do vídeo no app do Kwai, cole no Supadown e baixe. Sem instalar nada, funciona direto no navegador.',
            cta: 'Baixar vídeo do Kwai agora →',
            faq: [
                { q: 'Como pego o link de um vídeo no Kwai?', a: 'Abra o vídeo no app do Kwai, toque em "Compartilhar" e depois em "Copiar link".' },
                { q: 'Funciona com vídeos do Kwai em qualquer país?', a: 'Sim. O Supadown funciona com links do Kwai de qualquer região.' },
            ],
        },
        pinterest: {
            chipLabel: 'Pinterest',
            title: 'Baixar Vídeos do Pinterest Grátis',
            description: 'Baixe vídeos e Pins animados do Pinterest grátis. Downloader online sem cadastro.',
            heading: 'Baixar vídeos do Pinterest — grátis e online',
            intro: 'Baixe Pins com vídeo do Pinterest com o Supadown. Copie o link do Pin, cole no Supadown e baixe. Ideal para salvar tutoriais, receitas e inspirações visuais.',
            cta: 'Baixar vídeo do Pinterest agora →',
            faq: [
                { q: 'Posso baixar Pins que são imagens?', a: 'O Supadown é especializado em vídeos. Para imagens, use o botão de salvar do próprio Pinterest.' },
                { q: 'Funciona com Idea Pins?', a: 'Sim, desde que o Idea Pin contenha vídeo. Cole o link no Supadown normalmente.' },
            ],
        },
    },
};
